<template>
  <div class="row">
    <div class="col-md-12">
    <b-card>
    <search-tickets-seller
      class="mb-3"
      :filters="{date:'{{$date}}'}"
    ></search-tickets-seller>
      <b-table small
      :fields="tableHead"
      :items="tickets"
      responsive="sm"
    >
        <!-- A custom formatted column -->
        <template #cell(created_at)="data">
          {{ $moment(data.item.created_at).format('DD/MM/YYYY HH:mm') }}
        </template>
        <template #cell(is_used)="data">
        <font-awesome-icon v-if="data.item.is_used === 0" color="#F73B16" :icon="['fas', 'times-circle']"/>
       <font-awesome-icon v-if="data.item.is_used === 1" color="#90BF37" :icon="['fas', 'check-circle']"/> 
        </template>
      </b-table>
      </b-card>
    </div>
    <div class="col-md-4">
      
    </div>
  </div>
</template>
<script>
  import {NumberFormat} from "../../helpers/NumberFormat"
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  export default {
    name:'TicketsSupervisor',
    components:{FontAwesomeIcon},
    props:['tickets'],
    data() {
      return {
        loading:false,
        tableHead: [
          { key: 'id', label: 'ID' },
          { key: 'code', label: 'Code' },
          { key: 'created_at', label: 'Fecha de ingreso:' },  
          { key: 'users.name', label:'Vendedor:'}    ,
          { key: 'is_used', label: '¿Usado?'}
        ]
      }
    },
    methods:{
      numberFormat(number) {
        return NumberFormat.format(parseFloat(number), 2, ',', '.')
      },
      getZoneName(zone){
        if (zone == 'foreign') {
          return 'Foraneo'
        }
        return 'Local'
      }
    }
  }
</script>